import { render, staticRenderFns } from "./BookDeliveryPurchaseTab.vue?vue&type=template&id=219234a3&scoped=true"
import script from "./BookDeliveryPurchaseTab.vue?vue&type=script&lang=js"
export * from "./BookDeliveryPurchaseTab.vue?vue&type=script&lang=js"
import style0 from "./BookDeliveryPurchaseTab.vue?vue&type=style&index=0&id=219234a3&prod&scoped=true&lang=scss"
import style1 from "./BookDeliveryPurchaseTab.vue?vue&type=style&index=1&id=219234a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219234a3",
  null
  
)

export default component.exports